import { render } from "./IconOpenExternal.vue?vue&type=template&id=29fdcc64"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconOpenExternal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29fdcc64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29fdcc64', __exports__)) {
    api.reload('29fdcc64', __exports__)
  }
  
  module.hot.accept("./IconOpenExternal.vue?vue&type=template&id=29fdcc64", () => {
    api.rerender('29fdcc64', render)
  })

}


export default __exports__